<div class="iam-topbar">
  <div class="iam-topbar-left">
    <div class="p-pt-1 p-pl-3">
      <a routerLink="/personal-income-tax/tax-deduction" title="MS INVOICE">
        <img src="assets/iam/my-software/logo-mysoftware.png" alt="MS INVOICE" width="180px">
      </a>
    </div>
  </div>
  <div class="iam-topbar-right">
    <div class="iam-topbar-menu">
    </div>
    <ul class="iam-topbar-actions">
      <li class="iam-topbar-action">
        <a pRipple class="p-d-flex p-flex-row p-ai-center" href="https://zalo.me/3466644259078988323" target="_blank" title="Hỗ trợ trực tiếp">
          <img src="assets/images/zalo-60x60.png" alt="" class="p-mr-3" width="30">
          <span>Hỗ trợ trực tiếp</span>
        </a>
        <a pRipple class="p-d-flex p-flex-row p-ai-center" title="Hotline" (click)="entities.onTopbarActionClick($event, 'Contact')">
          <img src="assets/images/support.png" alt="" class="p-mr-3" width="30">
          <b>Hotline hỗ trợ</b>
        </a>
        <div class="flex-grow-1">
          <a pRipple style="height: 1.5rem; padding: 0 0.5rem"
             class="p-d-flex p-flex-row p-ai-center p-jc-between cursor-pointer w-100"
             (click)="$event.preventDefault(); $event.stopPropagation(); copyToClipboard('1900989920')">
            <b>1900.989.920</b>
            <!--          <i class="pi pi-copy" style="font-size: 0.9rem; opacity: 0.6;"></i>-->
          </a>
          <a pRipple style="height: 1.5rem; padding: 0 0.5rem"
             class="p-d-flex p-flex-row p-ai-center p-jc-between cursor-pointer w-100"
             (click)="$event.preventDefault(); $event.stopPropagation(); copyToClipboard('0941996979')">
            <b>0941.996.979</b>
            <!--              <i class="pi pi-copy" style="font-size: 0.9rem; opacity: 0.6;"></i>-->
          </a>
        </div>
        <div class="flex-grow-1">
          <a pRipple style="height: 1.5rem; padding: 0 0.5rem"
             class="p-d-flex p-flex-row p-ai-center p-jc-between cursor-pointer w-100"
             (click)="$event.preventDefault(); $event.stopPropagation(); copyToClipboard('0962626700')">
            <b>0962.626.700</b>
            <!--          <i class="pi pi-copy" style="font-size: 0.9rem; opacity: 0.6;"></i>-->
          </a>
          <a pRipple style="height: 1.5rem; padding: 0 0.5rem"
             class="p-d-flex p-flex-row p-ai-center p-jc-between cursor-pointer w-100"
             (click)="$event.preventDefault(); $event.stopPropagation(); copyToClipboard('0925567866')">
            <b>0925.567.866</b>
            <!--              <i class="pi pi-copy" style="font-size: 0.9rem; opacity: 0.6;"></i>-->
          </a>
        </div>
      </li>

      <li class="iam-topbar-action">
        <a pRipple class="rounded-circle" (click)="entities.onTopbarActionClick($event, 'Profile')" title="{{ 'Profile'|translate }}">
          <ng-container *ngIf="!logoData">
            <i class="pi pi-user pi-large"></i>
          </ng-container>
          <ng-container *ngIf="logoData">
            <img [src]="logoData" alt="" style="border-radius: 50%; width: 40px; height: 40px;">
          </ng-container>
          <span class="p-ml-2" *ngIf="user">{{ displayName }}</span>
        </a>
        <ul *ngIf="entities.activeTopbarAction === 'Profile'" class="iam-topbar-action-panel p-shadow-6">
          <li class="layout-topbar-action-item">
            <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="changePassword()">
              <i class="pi pi-unlock p-mr-2"></i>
              <span>{{ 'ChangePassword'|translate }}</span>
            </a>
          </li>
          <li class="layout-topbar-action-item">
            <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="logout()">
              <i class="pi pi-power-off p-mr-2"></i>
              <span>{{ 'Logout'|translate }}</span>
            </a>
          </li>
          <li class="p-pt-2 p-pr-3 p-pl-3 p-text-center">
            <span style="font-size: 12px;color: #616161;">{{ user['partyName'] }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
  <p-dialog header="{{ 'ChangePassword'|translate }}" [(visible)]="changingPassword" [style]="{width: '500px'}" [resizable]="false" position="top">
    <p-message severity="info" text="Xin quý khách lưu ý, để đảm bảo an ninh tài khoản nên dùng một mật khẩu đầy đủ yếu tố sau: Sử dụng ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường và số."></p-message>
    <div class="p-fluid p-formgrid p-grid p-mt-2">
      <div class="p-field p-col-12">
        <label for="oldPassword">{{ 'Password'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="oldPassword" formControlName="oldPassword">
        <app-validator [control]="changePasswordForm.get('oldPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPassword">{{ 'NewPassword'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="newPassword" formControlName="newPassword">
        <app-validator [control]="changePasswordForm.get('newPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPasswordVerify">{{ 'NewPasswordVerify'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="newPasswordVerify" formControlName="newPasswordVerify">
        <app-validator [control]="changePasswordForm.get('newPasswordVerify')"></app-validator>
      </div>
    </div>
    <p-message severity="error" [text]="changePasswordError" *ngIf="changePasswordError"></p-message>
    <p-footer>
      <p-button label="{{ 'ChangePassword'|translate }}" icon="pi pi-check" styleClass="p-button-raised" type="submit" [disabled]="changePasswordForm.invalid"></p-button>
      <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="changingPassword=false"></p-button>
    </p-footer>
  </p-dialog>
</form>
